import {
  memo,
  useEffect,
  useState,
  forwardRef,
} from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

import { sentimentPeriodFilters } from '../../../../data/directory/topics/topicsSentimentAnalysis';

import useSizes from '../../../../hooks/sizes';

import Tooltip from '../../../Tooltip';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

export const PeriodFilters = forwardRef(({
  onFilterChange,
  initialFilters = null,
  className = '',
}, ref) => {
  const [PeriodArr, setPeriodArr] = useState(
    initialFilters ?? sentimentPeriodFilters,
  );
  const { width } = useSizes();

  useEffect(() => {
    onFilterChange(PeriodArr.find(({ active }) => active)?.value);
  }, []);

  const setPeriodActiveFilter = (value) => {
    setPeriodArr((currentFilters) => (
      currentFilters.map((filter) => ({
        ...filter,
        active: filter.value === value,
      }))
    ));
    onFilterChange(value);
  };

  return (
    <div className={cx('period-filters', className)} ref={ref}>
      <ul className={Styles['period-filters-options']}>
        {PeriodArr
          .filter((f) => width > 768 || (width <= 768 && !f.mobileViewHidden))
          .map((filter) => (
            <li
              key={filter.value}
              className={cx('period-filters-option', { active: filter.active })}
              onClick={() => setPeriodActiveFilter(filter.value)}
            >
              <Tooltip
                icon={filter.text}
                className={Styles['period-filters-tooltip']}
                disableOnMobile
                hasBigScreenDesign
              >
                {filter.tooltip}
              </Tooltip>
            </li>
          ))}
      </ul>
    </div>
  );
});

PeriodFilters.propTypes = {
  onFilterChange: PropTypes.func,
};

PeriodFilters.defaultProps = {
  onFilterChange() {},
};

export default memo(PeriodFilters);
